import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';
import { pageview } from '../../config/analytics';

const TrackPageViews = () => {
  const location = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    // Only track pageviews for POP and PUSH navigation types
    if ((navType === 'POP' || navType === 'PUSH') && window.gtag) {
      pageview(location.pathname + location.search);
    }
  }, [location, navType]);

  return null; // This component doesn't render anything
};

export default TrackPageViews;
